import { graphql } from '@/gql';
import type { RemovePartnerCallerCreditsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const removePartnerCallerCredits = async ({
  phoneNumber,
  partnerCode,
  rideCredits,
  notes,
}: RemovePartnerCallerCreditsMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      partnerCode,
      rideCredits,
      notes,
    },
    mutation: graphql(`
      mutation RemovePartnerCallerCredits($phoneNumber: String!, $partnerCode: String!, $rideCredits: Float!, $notes: String!) {
        removePartnerCallerCredits(phoneNumber: $phoneNumber, partnerCode: $partnerCode, rideCredits: $rideCredits, notes: $notes) {
          callerId
          partnerId
          credits
          rides
        }
      }
    `),
  });

  return !!response.data?.removePartnerCallerCredits;
};
